export const DAO_CODE = 'TRAINING_SPECIALITIES' + '_DAO';
